import { render, staticRenderFns } from "./ProjectPage.vue?vue&type=template&id=7d27938a"
import script from "./ProjectPage.vue?vue&type=script&lang=js"
export * from "./ProjectPage.vue?vue&type=script&lang=js"
import style0 from "./ProjectPage.vue?vue&type=style&index=0&id=7d27938a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports